import { render } from "./PageListarPrazoAudiometria.vue?vue&type=template&id=78b5edaf"
import script from "./PageListarPrazoAudiometria.vue?vue&type=script&lang=js"
export * from "./PageListarPrazoAudiometria.vue?vue&type=script&lang=js"

import "./PageListarPrazoAudiometria.vue?vue&type=style&index=0&id=78b5edaf&lang=css"
/* custom blocks */
import block0 from "./PageListarPrazoAudiometria.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__